import { IChamp, Champ } from './champ';
import { IEntite } from './entite';
import { Localisation, ILocalisationLibelle } from './localisation';
import { Section } from './section';

export interface IOnglet {
    id?: string;
    entiteId: string;
    code: string;
    actif?: boolean;
    ordre: number;
    langues: Array<IOngletLibelle>;
    champs: Array<Champ>;
    sections: Array<Section>;
}

export interface IOngletLibelle extends ILocalisationLibelle {
    ongletId?: string;
}

export class Onglet extends Localisation<IOngletLibelle> implements IOnglet {

    id?: string;
    entiteId: string;
    code: string;
    actif?: boolean;
    ordre: number;
    champs: Array<Champ>;
    sections: Array<Section>;

    constructor(onglet: IOnglet) {
        super(onglet.langues);

        this.id = onglet.id;
        this.entiteId = onglet.entiteId;
        this.code = onglet.code;
        this.actif = onglet.actif;
        this.ordre = onglet.ordre;
        this.sections = onglet.sections;
        this.champs = onglet.champs;
    }

    static fromJson(onglet: any) {
        return new Onglet({
            id: onglet.ong_id,
            entiteId: onglet.ong_ent_id,
            code: onglet.ong_code,
            actif: onglet.ong_actif,
            ordre: parseInt(onglet.ong_ordre, 10),
            langues: onglet.langues.map(langue => {
                return {
                    id: langue.onl_id,
                    champId: langue.onl_ong_id,
                    langueId: langue.onl_lng_id,
                    libelle: langue.onl_libelle
                };
            }),
            sections: onglet.sections ? onglet.sections.map(section => {
                    return Section.fromJson(section);
            }) : [],
            champs: onglet.champs ? onglet.champs.map(champ => {
                //if (champ) {
                    return Champ.fromJson(champ);
                //}
            }) : []
        });
    }

    toJson() {
        return {
            ong_id: this.id,
            ong_ent_id: this.entiteId,
            ong_actif: this.actif,
            ong_ordre: this.ordre,
            ong_code: this.code,
            langues: this.langues.map(langue => {
                return {
                    onl_id: langue.id,
                    onl_ong_id: langue.ongletId,
                    onl_lng_id: langue.langueId,
                    onl_libelle: langue.libelle
                };
            }),
            sections: this.sections ? this.sections.map(section => {
                    return Section.fromJson(section);
            }) : [],
            champs: this.champs.map(champ => {
                return champ.toJson();
            })
        };
    }

    toOngletJson() {
        return {
            ong_id: this.id,
            ong_ent_id: this.entiteId,
            ong_actif: this.actif,
            ong_ordre: this.ordre,
            ong_code: this.code
        };
    }

    toChampOngletJson() {
        
        return {
            ong_id: this.id,
            ong_ent_id: this.entiteId,
            ong_actif: this.actif,
            ong_ordre: this.ordre,
            ong_code: this.code,
            langues: this.langues.map(langue => {
                return {
                    onl_id: langue.id,
                    onl_ong_id: langue.ongletId,
                    onl_lng_id: langue.langueId,
                    onl_libelle: langue.libelle
                };
            }),
            sections: this.sections ? this.sections.map(section => {
                    return section.toJson();
            }) : [],
            champs: this.champs.map(champ => {
                return champ.toChampOngletJson();
            })
        };
    }

    getChampsByColonne(colonneNumber: number) {
        return this.champs
            .filter(champ => champ.champOngletColonne === colonneNumber)
            .sort((a, b) => a.champOngletOrdre - b.champOngletOrdre);
    }

    findChampIndexByCoordonates(column: number, row: number): number {
        return this.champs.findIndex(champ => champ.champOngletOrdre === row && champ.champOngletColonne === column);
    }

    findChampByCoordonates(column: number, row: number): Champ {
        return this.champs[this.findChampIndexByCoordonates(column, row)];
    }

}
